(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSelectWorkstationForGateway (
    NetworkListService, $timeout, $filter, $http, WorkstationListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        onlyUploadConfiguration: '=onlyUploadConfiguration',
        paginationObject: '=paginationObject',
        tenant: '=tenant',
        callback: '&callback'
      },
      templateUrl: 'app/components/deployAssistant/defineNetwork/selectWorkstationForGateway/selectWorkstationForGateway.template.html',
      link: function(scope) {

        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';


        (function() {
          setPosition()
          getFirstPage();
        })();

        function setPosition () {
          let element =  document.querySelector('.select-fake-list-float')
          let elementRatio = element.getBoundingClientRect()
          if ((elementRatio.bottom + 30) > window.innerHeight) {
            element.style.top = `-${elementRatio.bottom - window.innerHeight}px`
          }
        }

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;

          WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = workstations.page.totalPages;
            if (workstations.list) {
              scope.list = workstations.list;
            }
          }).catch(function(error) {
            console.log(error);
          });
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;

            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations){
              if (workstations.list) {
                scope.list = scope.list.concat(workstations.list);
              }
              scope.loadingPage = false;
            }).catch(function(error) {});
          }
        }

        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });



        scope.$on('$destroy', function() {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({selectedItem: selectedItem})
        }

        scope.closePopup = function (event) {
          scope.callback({selectItem: null});
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'networkTooltip':
                networkTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'networkAllDetails',
            network: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 500},
            contextMenu: false
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxSelectWorkstationForGateway.$inject = ['NetworkListService', '$timeout', '$filter', '$http', 'WorkstationListService'];

  angular
    .module('printix-admin')
    .directive('pxSelectWorkstationForGateway', pxSelectWorkstationForGateway);

})();
